import http from '@utils/http';
import { addNotification } from '@services/notifications.service';

/**
 * GET /api/v1/app-bugs
 */
export const fetchBugReports = async () => {
    try {
        const res = await http.get('/app-bugs');
        const raw = res.data?.data ?? res.data;

        let items = [];
        if (Array.isArray(raw)) {
            items = raw;
        } else if (raw && typeof raw === 'object') {
            items =
                raw.items ??
                raw.data ??
                raw.reports ??
                raw.bugs ??
                raw.bugReports ??
                raw.rows ??
                [];
        }

        if (!Array.isArray(items)) items = [];

        return items.map((r) => ({
            ...r,
            links: Array.isArray(r?.links) ? r.links : [],
            files: Array.isArray(r?.files) ? r.files : [],
        }));
    } catch (err) {
        console.error('Failed to fetch bug reports from API:', err);
        return [];
    }
};

/** Compatibility helper */
export const getStoredBugReports = () => {
    return [];
};

/**
 * POST /api/v1/app-bugs
 */
export const createBugReport = async (payload, currentUser) => {
    const formattedLinks = (payload.links || []).map((l, i) => ({
        id: l.id || `link-${Date.now()}-${i}`,
        url: l.url || l.href,
        title: l.title || l.url,
    }));

    const formattedFiles = (payload.files || []).map((f, i) => ({
        id: f.id || `file-${Date.now()}-${i}`,
        name: f.name || f.title || `attachment_${i + 1}`,
        type: f.type || '',
        preview: f.preview || '',
    }));

    const res = await http.post('/app-bugs', {
        title: payload.title,
        description: payload.description,
        links: formattedLinks,
        files: formattedFiles,
    });

    const newReport = res.data?.data ?? res.data;

    addNotification({
        title: `Ticket #${newReport.ticketNumber || 'New'} Created`,
        message: `Thank you for reporting! Ticket #${newReport.ticketNumber || 'New'} ("${payload.title}") has been received. Our team will resolve it as soon as possible.`,
        type: 'bug_report',
        metadata: { ticketNumber: newReport.ticketNumber, bugId: newReport.id },
    });

    return newReport;
};

/**
 * PATCH /api/v1/app-bugs/:id/status
 */
export const updateBugReportStatus = async (id, newStatus, actorUser) => {
    const res = await http.patch(`/app-bugs/${id}/status`, { status: newStatus });
    const updated = res.data?.data ?? res.data;

    if (newStatus === 'done' && updated) {
        addNotification({
            title: `Ticket #${updated.ticketNumber} Resolved`,
            message: `Your ticket #${updated.ticketNumber} ("${updated.title}") has been marked as Done. Thank you for your feedback!`,
            type: 'bug_resolved',
            metadata: { ticketNumber: updated.ticketNumber, bugId: updated.id },
        });
    }

    return updated;
};

/**
 * DELETE /api/v1/app-bugs/:id
 */
export const deleteBugReport = async (id) => {
    const res = await http.delete(`/app-bugs/${id}`);
    return res.data?.data ?? res.data;
};
